import FotoscapesURL from '../../assets/common/scripts/fotoscape/FotoscapesURL'

document.addEventListener('DOMContentLoaded', () => {
  const imaOptions = {
    id: 'video-js',
    adTagUrl:
      'https://pubads.g.doubleclick.net/gampad/ads?iu=/180049092/ROS_LB_LOOKBK_MWEB_EN_VIDEO&description_url=http%3A%2F%2Ffotoscapes.com&tfcd=0&npa=0&sz=400x300&min_ad_duration=5000&max_ad_duration=15000&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator='
  }

  const mediaURL = FotoscapesURL.getMediaURL();

  const WATERFALL = {
    videoScr: {
      src: `${mediaURL}/movies/waterfall/waterfall.m3u8`,
      type: 'application/x-mpegURL'
    },
    captions: [{
      lang: 'en',
      src: `${mediaURL}/movies/waterfall/waterfall.en.vtt`
    }]
  }

  const EARTH = {
    videoScr: {
      src: `${mediaURL}/movies/earth/earth.m3u8`,
      type: 'application/x-mpegURL'
    },
    captions: [{ lang: 'en', src: `${mediaURL}/movies/earth/earth.en.vtt` }]
  }

  const FERRARI = {
    videoScr: {
      src: `${mediaURL}/movies/ferrari/ferrari.m3u8`,
      type: 'application/x-mpegURL'
    },
    captions: [{ lang: 'en', src: `${mediaURL}/movies/ferrari/ferrari.en.vtt` }]
  }

  const SOURCE_LIST = [
    WATERFALL, EARTH, FERRARI
  ]

  //@ts-ignore
  const player = window.videojs('video-js', {
    preload: 'auto',
    autoplay: true,
    muted: true,
    html5: {
      vhs: {
        overrideNative: true
      }
    }
  })

  const trackIndex = Math.floor(Math.random() * SOURCE_LIST.length)

  player.src(SOURCE_LIST[trackIndex].videoScr)

  SOURCE_LIST[trackIndex].captions.forEach(trackData => {
    player.addRemoteTextTrack({
      kind: 'captions',
      label: trackData.lang,
      src: trackData.src,
      mode: 'showing',
      default: true
    }, false)
  })

  try {
    player.ima(imaOptions)
  } catch (e) {
    console.warn(e)
  }
})
